export enum TeamSize {
  to5 = 'to5',
  to10 = 'to10',
  to20 = 'to20',
  to50 = 'to50',
  to100 = 'to100',
  to250 = 'to250',
  to500 = 'to500',
  to1000 = 'to1000',
  moreThan1000 = 'moreThan1000',
}

export enum Industry {
  agency = 'agency',
  banking = 'banking',
  businessServices = 'businessServices',
  consulting = 'consulting',
  constructionEngineering = 'constructionEngineering',
  consumerGoods = 'consumerGoods',
  education = 'education',
  energy = 'energy',
  entertainmentMedia = 'entertainmentMedia',
  financialServices = 'financialServices',
  foodBeverage = 'foodBeverage',
  government = 'government',
  healthcare = 'healthcare',
  hospitality = 'hospitality',
  insurance = 'insurance',
  legal = 'legal',
  manufacturing = 'manufacturing',
  nonProfit = 'nonProfit',
  retail = 'retail',
  technology = 'technology',
  telecommunication = 'telecommunication',
  transportation = 'transportation',
}
